var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login__page"},[_c('div',{staticClass:"login__card"},[_c('div',{staticClass:"login__content"},[_c('TheLoginForm',{on:{"success":_vm.returnToApp}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }